var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"app-container",attrs:{"id":_vm.isTheme1 ? 'theme1' : ''}},[(_vm.showPage)?[_c('router-view')]:_c('div')],2)}
var staticRenderFns = []

export { render, staticRenderFns }